<template>
  <div class="attach-product-feature" v-bind:class="[demo.orientation == 'right' ? 'shift-right' : 'shift-left']">
    <img src="../../assets/iphone-7-white.png" class="product-item-image-overlay">
    <video :src="demo.videoSrc" muted playsinline autoplay loop class="attach-video-holder"></video>
  </div>
</template>

<script>
export default {
  props: [ 'demo' ],
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>
.attach-product-feature {
  display: block;
  text-align: center;
  width: 300px;
  margin: 24px auto;
  min-height: 600px;
}

.shift-right {
  margin-right: -12px;
}

.shift-left {
  margin-left: -12px;
}

@media only screen and (max-width: 650px) {
  .attach-product-feature {
    margin: 0 auto;
  }
}

.product-item-image-overlay {
  display: block;
  position: absolute;
  width: 300px;
}

.attach-video-holder {
  display: block;
  position: absolute;
  margin-left: 15px;
  margin-top: 63px;
  width: 269px;
  border: 1px solid #dedede;
  min-height: 475px;
}
</style>



// WEBPACK FOOTER //
// PhoneAndVideoComponent.vue?5173121e